const debug = process.env.REACT_APP_DEBUG && false;
export const sortTreeDefinition = (treeDef, order, canary = '') => {
    debug && console.log(`Sorting ${canary === '' ? 'Whole tree' : canary} with`, order, treeDef);
    let sortedTreeDef = {};
    for (const [menuKey, sortObj] of Object.entries(order)) {
        if (!treeDef[menuKey]) {
            continue;
        }
        if (Object.keys(sortObj).length === 0) {
            sortedTreeDef[menuKey] = treeDef[menuKey];
        }
        else {
            if (treeDef[menuKey].next) {
                sortedTreeDef[menuKey] = treeDef[menuKey];
                sortedTreeDef[menuKey].next = sortTreeDefinition(treeDef[menuKey].next, sortObj, `${canary} > ${menuKey}`);
            }
            else {
                sortedTreeDef[menuKey] = treeDef[menuKey];
            }
        }
    }
    // Dump all the unspecified stuff at the end in tree defs default definition order (note that this can be unpredictable cos of
    for (const [menuKey, menuDef] of Object.entries(treeDef)) {
        if (!Object.keys(order).find((orderKey) => orderKey === menuKey)) {
            sortedTreeDef[menuKey] = treeDef[menuKey];
        }
    }
    debug && canary === '' && console.log('Fully sorted tree:', sortedTreeDef, order);
    return sortedTreeDef;
};
